<div class="d3-chart" #chartContainer ></div>
